<template>
  <div
  class="NoFilesPage">
    <img
      src="/images/empty-media.jpg"
      class="NoFilesPage__photo"/>
      <span
      class="NoFilesPage__title">
        No files yet
      </span>
  </div>
</template>

<script>
export default {
  name: 'NoFilesPage'
}
</script>

<style lang="scss" scoped>
.NoFilesPage {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  animation: fadeIn 0.65s;

  &__photo {
    margin: 10px 0px 10px 35px;
    width: 145px;
    height: 111px;
  }
  &__title {
    padding: 10px;
  }
  @media only screen and (min-width: $bp-md-min) {
    &__photo {
      margin: 10px 0px 10px 71px;
      width: 290px;
      height: 223px;
    }
  }
}
</style>
